<template>
  <toggle-button
    :width="35"
    :height="20"
    class="mb-0"
    @change="handleToggleLeaderboard()"
    :value="hasLeaderboard()"
    :sync="true"
    :color="{checked: '#348EF6', unchecked: '#D3D7E1'}"
  />
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/util'
import EventBus from '@/eventBus'

export default {
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
  },
  methods: {
    hasLeaderboard() {
      const { slides } = this.presentation
      const indexSlide = utils.getIndexSlide(
        slides,
        this.slideActive.id,
      )
      if (indexSlide === slides.length - 1 || slides.length === 1) {
        return false
      }
      if (slides[indexSlide + 1].type !== 'leaderboard') {
        return false
      }
      return true
    },
    handleToggleLeaderboard() {
      if (this.hasLeaderboard()) {
        this.removeLeaderboard()
      } else {
        this.addLeaderboard()
      }
    },
    addLeaderboard() {
      EventBus.$emit('addSlideLeaderboard')
    },
    removeLeaderboard() {
      EventBus.$emit('removeSlideLeaderboard')
    },
  },
}
</script>
